import { getATLContextDomain } from '@atlassian/atl-context';

/**
 * Returns a URL that ensures the user is logged in to the correct account before redirecting to the given `pageUrl`.
 * For example, ensuring that the user is logged in to the same account on WAC before redirecting to the JSTO page.
 */
export function getLoggedInPage(userEmail: string, pageUrl: string) {
	const encodedPageUrl = encodeURIComponent(pageUrl);
	const encodedUserEmail = encodeURIComponent(userEmail);

	// This URL will take them through the login flow (if necessary) then redirect them to the given (encoded) `pageUrl`.
	return `https://${getATLContextDomain('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
}
